//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'delivery-records',
  props: {
    planId: {
      required: true,
      type: Number
    },
    status: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCount: 0,
      list: [],
      searchInput: {},
      loading: false,
      columns: [
        {type: 'index', width: 60, align: 'center'},
        // { title: '计划名称', align: 'center', key: 'planName' },
        {title: '项目名称', align: 'center', key: 'projectName'},
        {title: '房号', key: 'roomNum', align: 'center', minWidth: 99},
        {
          key: 'name', title: '联系信息', align: 'center', minWidth: 99,
          render(h, params) {
            let row = params.row;
            let actions = [];
            actions.push(h('p', '联系人：' + row.name));
            actions.push(h('p', '联系电话：' + row.mobile));
            return h('div', actions);
          }
        },
        {title: '状态', align: 'center', key: 'statusStr'},
        {
          title: '操作', align: 'center',
          render: (h, params) => {
            let row = params.row;
            let actions = [];
            actions.push(h('Button', {
              props: {
                type: 'default',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  // vm.editCity(params.row);
                  this.$router.push({
                    path: '/reservationInfo/' + row.recordId
                  });
                }
              }
            }, '查看'));


            return h('div', actions);
          }
        }
      ]
    };
  },
  methods: {
    pageChange(page) {
      this.currentPage = page;
      this.getPage();
    },
    pageSizeChange(pagesize) {
      this.pageSize = pagesize;
      this.getPage();
    },
    getPage() {
      this.loading = true;
      this.searchInput.planId = this.planId;
      this.searchInput.messageType = this.status;
      this.searchInput.maxResultCount = this.pageSize;
      this.searchInput.skipCount = (this.currentPage - 1) * this.pageSize;
      abp.ajax.get('/api/services/app/DeliveryRecord/GetDeliveryRecordNotices', {params: this.searchInput}).then(res => {
        this.list = [];
        this.list.push(...res.data.result.items);
        this.totalCount = res.data.result.totalCount;
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.getPage();
  }
};
